import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { portalActions } from "../../store/portal-slice";
import { getLocalStore, setLocalStore } from "helpers/localStoreSrv";
import { useApi } from "helpers/useApi";
export const useSurveySrv = () => {
  const dispatch = useDispatch();
  const { api } = useApi();
  const portalSessionMeta = useSelector(
    (state: any) => state.portal.micrositeSession
  );

  const postSurveySrv = (surveyid: any) => {
    return api.post(`MemberActivities/ByReference`, JSON.stringify(surveyid));
  };

  const patchSurveySrv = (data: any) => {
    if (portalSessionMeta.urlRef) {
      return api.patch(`MemberActivities`, data);
    }
  };
  const getSurevyData = () => {
    if (portalSessionMeta.urlRef) {
      let payload = JSON.stringify(portalSessionMeta.urlRef);
      return api.post("/api/MemberActivities/ByReference/", payload);
    } else {
      return new Promise((resolve, reject) => {
        reject({ status: 401 });
      });
    }
  };
  const getMedicaidIDCardData = () => {
    if (portalSessionMeta.urlRef) {
      return api.get(`/api/memberactivities/registrationCode/${portalSessionMeta.urlRef}`);
    } else {
      return new Promise((resolve, reject) => {
        reject({ status: 401 });
      });
    }
  };
  const submitSurveyData = (surveyData: any) => {
    if (portalSessionMeta.urlRef) {
      console.log("inner", surveyData);
      return api.patch("/api/MemberActivities/", surveyData);
    }
  };
  const memberPortalsubmitSurveyData = (surveyData: any) => {
    return api.post("/api/survey", surveyData);
  };

  const familySurveyPendingSurveys = () => {
    return api.get(`/api/survey/family`);
  };
  const partialSurveyData = (surveyData: any) => {
    if (portalSessionMeta.urlRef) {
      return api.post("/api/memberactivities/partial", surveyData);
    }
  };
  const partialSurveyDataRulebased = (surveyData: any) => {
    return api.post("/api/survey/partial", surveyData);
  };
  const restoreMicrositeSession = (micrositeSession: any) => {
    console.log(micrositeSession);
    dispatch(portalActions.updateMicrositeSession(micrositeSession));
  };
  const submitUploadDocument = (payload: any) => {
    return api.postForm(
      "/api/memberactivities/uploadquestiondocument",
      payload
    );
  };
  const deleteDocument = (id: any) => {
    return api.delete(
      `/api/memberactivities/deletequestiondocument/?patientActivityDetailID=${id}`
    );
  };
  const lastSeenPageNumberData = (id: any, patientactivityID: any) => {
    return api.post(
      `/api/survey/lastseenpagenumber?lastseenPageNumber=${id}`,
      JSON.stringify(patientactivityID)
    );
  };
  const getLanguageTranslations = (transGrpId: string, preferredLanguage: any) => {
    return api.post(
      "api/survey/translations",
      JSON.stringify({
        TranslationGroupID: transGrpId,
        LanguageCode: preferredLanguage
      })
    );
  };
  const updatePatientActivityDetailID = (payload: any) => {
    return api.post("/api/survey/saveandretrievesurvey", payload);
  };
  const updateSelectedLanguageFromDropDown = (payload: any) => {
    return api.post("/api/member/updatepreferredlanguage", payload);
  };
  const preferredLanguageData = (payload: any) => {
    return api.post("/api/memberactivities/partial/language", payload);
  };
  const getVideoCampaignData = (campaignName: any, userRegistrationCode: any) => {
    if (campaignName && userRegistrationCode) {
      return api.get(`/api/videoCampaign/${campaignName}/${userRegistrationCode}`);
    } else {
      return Promise.reject({ status: 401 });
    }
  };
  const sendAnalytics = (payload: any) => {
    console.log("analytics payload:", payload);
    return api.post("/api/videoCampaign", payload);
  };
  const trackMediCardDownload = (payload: any) => {
    console.log("medicard payload:", payload);
    return api.post("/api/memberactivities/downloadlogs", payload);
  };
  useEffect(() => {
    console.log(portalSessionMeta);
    if (!!portalSessionMeta.urlRef) setLocalStore("MS", portalSessionMeta);
  }, [portalSessionMeta]);
  useEffect(() => {
    const prevMS = getLocalStore("MS");
    if (prevMS) restoreMicrositeSession(prevMS);
  }, []);
  return {
    postSurveySrv,
    getLanguageTranslations,
    partialSurveyDataRulebased,
    patchSurveySrv,
    familySurveyPendingSurveys,
    getSurevyData,
    submitSurveyData,
    partialSurveyData,
    memberPortalsubmitSurveyData,
    submitUploadDocument,
    updatePatientActivityDetailID,
    deleteDocument,
    preferredLanguageData,
    lastSeenPageNumberData,
    updateSelectedLanguageFromDropDown,
    getMedicaidIDCardData,
    getVideoCampaignData,
    sendAnalytics,
    trackMediCardDownload
  };
};
